import styled from 'styled-components';
import { DropdownIcon, MinusIcon, PlusIcon } from '../../assets';
export const AccordionHeader = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2.1rem 2.4rem;

  cursor: pointer;
  border-bottom: 1px solid ${({ theme }) => theme.colors.borders.default};

  ${({ theme }) => theme.media.tablet `
    padding: 4rem 2.4rem;
  `};
`;
export const AccordionBody = styled.div `
  height: ${({ isOpen }) => (isOpen ? 'auto' : '0px')};
  overflow: hidden;
  padding: ${({ isOpen }) => (isOpen ? '2.2rem 4rem' : '0 3.8rem')};
  padding: ${({ isOpen, component }) => isOpen && component && '3rem 0rem 4.5rem'};

  ${({ theme, isOpen, component }) => {
    const padding = isOpen && component && '3rem 8rem 2.2rem';
    return theme.media.tablet `
    padding: ${padding}
  
    `;
}}
  margin-bottom: ${({ isOpen }) => (isOpen ? '1rem' : '0')};

  transition: padding 0.2s ease;

  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;
export const TitleContainer = styled.div `
  display: flex;
  align-items: center;
`;
export const QuestionMarkContainer = styled.div `
  margin-right: 3rem;
`;
export const CustomMinusIcon = styled(MinusIcon) `
  width: 9px;
  height: 9px;
`;
export const CustomPlusIcon = styled(PlusIcon) `
  width: 9px;
  height: 9px;
`;
export const CustomIconWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 2.1rem;
  min-height: 2.1rem;
  border-radius: ${({ theme }) => theme.borderRadius.highest};
  border: 1px solid ${({ theme }) => theme.colors.text.default};
`;
export const AccordionCont = styled.div `
  background-color: ${({ theme, isOpen, backgroundColor }) => isOpen ? theme.colors.interactive.secondaryDisabled : backgroundColor};
  transition: background-color 0.1s ease-in;
`;
export const QuestionMark = styled.div `
  width: 1rem;
  height: 1rem;
  border-radius: ${({ theme }) => theme.borderRadius.highest};
  background-color: ${({ theme }) => theme.colors.interactive.brandColor};
`;
export const CustomDropDownIcon = styled(DropdownIcon) `
  transform: rotate(180deg);

  ${({ theme }) => theme.media.laptop `
    display: none;
  `};
`;
//# sourceMappingURL=styles.js.map